import { render } from "./BoxLinkSm.vue?vue&type=template&id=1d9a53f8&scoped=true&lang=pug"
import script from "./BoxLinkSm.vue?vue&type=script&lang=js"
export * from "./BoxLinkSm.vue?vue&type=script&lang=js"

import "./BoxLinkSm.vue?vue&type=style&index=0&id=1d9a53f8&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d9a53f8"]])

export default __exports__